import React, { ChangeEvent, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  CardMedia,
  IconButton,
  Input,
  MenuItem,
  TextField,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const EditBadge = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const badgeData = (location.state && location.state.badge) || {};

  const [image, setImage] = useState<string>(badgeData.image || "");
  const [fileName, setFileName] = useState<string>("");

  const [title, setTitle] = useState<string>(badgeData.title || "");
  const [description, setDescription] = useState<string>(
    badgeData.description || ""
  );

  /** NEW FIELDS */
  const [criteriaType, setCriteriaType] = useState<string>(
    badgeData.criteriaType || ""
  );
  const [targetValue, setTargetValue] = useState<string>(
    badgeData.targetValue || ""
  );
  const [usageLimit, setUsageLimit] = useState<string>(
    badgeData.usageLimit || ""
  );
  const [customLimit, setCustomLimit] = useState<string>("");

  const [eligibleUsers, setEligibleUsers] = useState<string>(
    badgeData.eligibleUsers || ""
  );

  return (
    <>
      <div className="main_title">
        <h1>Edit Badge</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-badges")}>
            Manage Achievements & Badges
          </button>{" "}
          - Edit Badge
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            {/* Badge Image */}
            <div className="control_group w_33">
              <label>Badge Image*</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="Badge" />
                    </figure>
                    <IconButton
                      aria-label="Remove uploaded image"
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      const files = e.target.files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/badge_placeholder.png"
                        alt="placeholder"
                        style={{ objectFit: "contain" }}
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* Title */}
            <div className="control_group w_33">
              <label>Badge Title*</label>
              <TextField
                placeholder="Enter Badge Title"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            {/* Criteria Type */}
            <div className="control_group w_33">
              <label>Criteria Type*</label>
              <Select
                value={criteriaType}
                onChange={(e) => setCriteriaType(e.target.value)}
                displayEmpty
                renderValue={(selected) =>
                  !selected ? (
                    <span style={{ color: "#999" }}>Select Criteria</span>
                  ) : (
                    selected
                  )
                }
                fullWidth
              >
                <MenuItem value="">
                  <span style={{ color: "#999" }}>Select Criteria</span>
                </MenuItem>
                <MenuItem value="Workouts">Workouts</MenuItem>
                <MenuItem value="Steps">Steps</MenuItem>
                <MenuItem value="Calories">Calories</MenuItem>
                <MenuItem value="Day Streak">Day Streak</MenuItem>
                <MenuItem value="Program Completion">Program Completion</MenuItem>
              </Select>
            </div>

            {/* Target Value */}
            <div className="control_group w_33">
              <label>Target Value*</label>
              <TextField
                placeholder="Enter Number"
                fullWidth
                type="number"
                value={targetValue}
                onChange={(e) => setTargetValue(e.target.value)}
              />
            </div>

            {/* Usage Limit */}
            <div className="control_group w_33">
              <label>Usage Limit*</label>
              <Select
                value={usageLimit}
                onChange={(e) => setUsageLimit(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  <span style={{ color: "#999" }}>Select Usage Limit</span>
                </MenuItem>
                <MenuItem value="unlimited">Unlimited</MenuItem>
                <MenuItem value="once">Once</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </Select>

              {usageLimit === "custom" && (
                <TextField
                  type="number"
                  placeholder="Enter limit count"
                  fullWidth
                  style={{ marginTop: "10px" }}
                  value={customLimit}
                  onChange={(e) => setCustomLimit(e.target.value)}
                />
              )}
            </div>

            {/* Eligible Users */}
            <div className="control_group w_33">
              <label>Eligible Users*</label>
              <TextField
                placeholder="e.g., All Users, Premium Users"
                fullWidth
                value={eligibleUsers}
                onChange={(e) => setEligibleUsers(e.target.value)}
              />
            </div>

            {/* Description */}
            <div className="control_group w_100">
              <label>Description*</label>
              <TextField
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          {/* Save Button */}
          <div className="form_btn">
            <Button className="btn btn_primary">Save Changes</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditBadge;
